import {
  TabOption,
  TAB_SEARCH_PARAM,
  getTabSlug
} from "@/components/layouts/DetailedView";
import { getDealDetailedViewUrl } from "@/services/hooks/entities/deal/useDealsNavigation";
import {
  EntityType,
  entityTypeToEntityName
} from "@/services/hooks/entities/useEntityType";

// Opens the record's Activities tab with the activity expanded.
export const getEntityActivityUrl = (
  entityType: EntityType,
  entityId: string,
  activityId: string
): string => {
  const extraParams = {
    [TAB_SEARCH_PARAM]: getTabSlug(TabOption.ACTIVITIES),
    expandedActivityId: activityId
  };
  if (entityType === EntityType.DEAL) {
    return getDealDetailedViewUrl(entityId, extraParams);
  }
  const searchParams = new URLSearchParams(extraParams);
  return `/${entityTypeToEntityName[entityType]}/${encodeURIComponent(entityId)}?${searchParams.toString()}`;
};
